module.exports = __webpack_public_path__ + "img/square-root-variable.cf33f7c2.svg";